import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {apiQuery} from "../../utils/AppConfig";
import {Response} from "../../types/response/Response";
import {ResponsePageable} from "../../types/response/ResponsePageable";
import {PartnerDTO} from "../../types/partner/PartnerDTO";
import {PartnerCreateDTO} from "../../types/partner/PartnerCreateDTO";
export const partnerApi = createApi({
    reducerPath: 'partnerUrl',
    baseQuery: apiQuery,
    tagTypes: ['partnerUrl'],
    endpoints: builder => ({
        getPartners: builder.query<Response<ResponsePageable<PartnerDTO[]>>, {
            params: string
        }>({
            query: (dto) => ({
                url: `/partners?${dto.params}`,
                method: 'GET'
            }),
            providesTags: ['partnerUrl']
        }),
        createPartner: builder.mutation<void, Partial<PartnerCreateDTO>>({
            query: (dto) => ({
                url: '/partners',
                method: 'POST',
                body: dto
            }),
            invalidatesTags: ['partnerUrl']
        }),
        updatePartner: builder.mutation<void, Partial<{ id: string, dto: PartnerCreateDTO }>>({
            query: ({id, dto}) => ({
                url: `/partners/${id}`,
                method: 'PATCH',
                body: dto
            }),
            invalidatesTags: ['partnerUrl']
        }),
        deletePartner: builder.mutation<void, string>({
            query: (id) => ({
                url: `/partners/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['partnerUrl']
        }),
        getPartnerQrCode: builder.mutation<string, string>({
            query: (id) => ({
                url: `/partners/${id}/qr-code`,
                method: 'GET'
            }),
            transformResponse: (response: { data: string }) => response.data
        })
    })
})

export const {
    useLazyGetPartnersQuery,
    useCreatePartnerMutation,
    useUpdatePartnerMutation,
    useDeletePartnerMutation,
    useGetPartnerQrCodeMutation
} = partnerApi